import React from "react";

import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";

import { Grid, Typography, Avatar } from "@mui/material";

import { useSelector } from "react-redux";

import AdminSideNavbar from "../AdminSideNavbar";

import EntityTable from "../EntityTable";

import { ComponentType, OrganizationTab } from "../../../common/enum";
import { organizationDashboardMenu } from "../../../data";

import ActionComponentRenderer from "../EntityTable/ActionComponentRenderer";
import Datagrid from "../../Datagrid";
import PendingApproval from "../PendingApproval";
import PendingRegister from "../PendingApproval/PendingRegister";
const Organizations = ({ t }) => {
  const allColumnDefs = [
    {
      headerName: t("id"),
      field: "entityId",
    },
    {
      headerName: t("name"),
      field: "name",
    },
    {
      headerName: t("totalDonations"),
      field: "totalDonation",
    },
    {
      headerName: t("totalCollections"),
      field: "totalCollection",
    },
    {
      headerName: t("companyType"),
      field: "isParentEntity",
    },
    {
      headerName: t("noOfChild"),
      field: "totalChild",
    },
    {
      headerName: t("lastActiveDate"),
      field: "lastActiveDate",
    },
    {
      headerName: t("district"),
      field: "district",
    },
    {
      headerName: t("county"),
      field: "county",
    },
    {
      headerName: t("parshi"),
      field: "subDivision",
    },
    {
      headerName: t("action"),
      cellRenderer: ActionComponentRenderer,
      colId: "params",
      editable: false,
      filter: false,
      sortable: false,
      cellRendererParams: { value: OrganizationTab.ALL },
    },
  ];

  const pendingColumnDefs = [
    {
      headerName: t("name"),
      field: "name",
    },
    {
      headerName: "Type",
      field: "type",
    },
    {
      headerName: t("activity"),
      field: "areaOfActivity",
    },
    {
      headerName: t("entityType"),
      field: "entityType",
    },
    {
      headerName: t("dateOfApplication"),
      field: "createdDate",
    },
    {
      headerName: t("district"),
      field: "district",
    },
    {
      headerName: t("county"),
      field: "county",
    },
    {
      headerName: t("parshi"),
      field: "subDivision",
    },
    {
      headerName: t("action"),
      cellRenderer: ActionComponentRenderer,
      colId: "params",
      editable: false,
      filter: false,
      sortable: false,
      cellRendererParams: { value: OrganizationTab.PENDING },
    },
  ];

  const {
    adminDashboard: {
      organizationDashboardTab = organizationDashboardMenu[0].title,
    },
  } = useSelector((state) => state);

  return (
    <TabContext
      value={
        organizationDashboardTab
          ? organizationDashboardTab
          : organizationDashboardMenu[0].title
      }
      orientation="vertical"
      centered
    >
      <AdminSideNavbar t={t} component={ComponentType.ORGANIZATIONS} />

      <TabPanel
        value={organizationDashboardMenu[0].title}
        sx={{
          px: 0,
        }}
      >
        {/* <EntityTable
          t={t}
          component={OrganizationTab.PENDING}
          columnDefs={pendingColumnDefs}
          elevation={4}
        /> */}
        <PendingApproval t={t} />
      </TabPanel>
      <TabPanel
        value={organizationDashboardMenu[1].title}
        sx={{
          px: 0,
        }}
      >
       
        <PendingRegister t={t} />
      </TabPanel>
      {/* <TabPanel value={organizationDashboardMenu[1].title} sx={{ px: 0 }}>
        <EntityTable
          t={t}
          component={OrganizationTab.ALL}
          columnDefs={allColumnDefs}
          elevation={4}
        />
      </TabPanel> */}
      <TabPanel
        value={organizationDashboardMenu[2].title}
        sx={{
          px: 0,
        }}
      >
        <Datagrid t={t} />
      </TabPanel>
    </TabContext>
  );
};

export default Organizations;
